module.exports = {
    tag: 'coarse',
    quality: 0,
    dexterity: -2,
    regeneration: -0.5
};